const mobileNav = {
    openBtn: document.querySelector('.e-mobileFilterBtn'),
    closeBtn: document.querySelector('.e-closeMenuBtn'),
    menu: document.querySelector('.m-mobileNavMenu'),
    accordionItems: document.querySelectorAll('.c-accordion button'),
    open: function() {
        this.openBtn.style.display = 'none'
        this.menu.style.display = 'block'
        this.closeBtn.style.display = 'block'
    },
    close: function() {
        this.openBtn.style.display = 'block'
        this.menu.style.display = 'none'
        this.closeBtn.style.display = 'none'
    },
    toggleAccordion: function() {
        const itemToggle = this.getAttribute('aria-expanded')
        for(i = 0; i < mobileNav.accordionItems.length; i++) mobileNav.accordionItems[i].setAttribute('aria-expanded', 'false')
        if(itemToggle == 'false') this.setAttribute('aria-expanded', 'true')
    }
}

mobileNav.openBtn.addEventListener('click', function() {mobileNav.open()})
mobileNav.closeBtn.addEventListener('click', function() {mobileNav.close()})
mobileNav.accordionItems.forEach(item => item.addEventListener('click', mobileNav.toggleAccordion))

/* update absolute path to relative path */
const replaceAbsolutePath = () => {
    const links = document.querySelectorAll('.inner-banner-content a')
    let I = links.length
    while(I--) {
        let link = links[I].href
        const replaced = link.replace(/https:\/\/makesy.com|https:\/\/woodenwick.com/, '')
        links[I].href = replaced
    }
}
addEventListener('DOMContentLoaded', (event) => {
  replaceAbsolutePath()
})
/* End update absolute path to relative path */